import React from 'react';
import { Link } from "react-router-dom";
import Mrindian from "../images/MR. INDIAN CODER FINAL LOGO Update 04 Sep, 2025.jpg";
import "./Navbar.css";
// import Fileupload from "../pages/Fileupload";

function Header() {



  return (
    <>
      <div className="fixed-top">
        <div className="mrindiancoder">
          <div className="album py-1">

            <div className="container">

              <div className="row">

                <div className="col-md-5" >
                  <div className="d-flex justify-content-between align-items-center">

                  <a style={{color:"white"}} href='tel:+91 9933798896'> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-plus" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
  <path fill-rule="evenodd" d="M12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5"/>
</svg>  +91 9933798896</a>

                    <a href='booknow'>
                      <button style={{ pading: "2px" }} className="franchise"> Book Now <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg>   </button>
                    </a>



                  </div>

                </div>

                <div className="d-flex justify-content-between align-items-center">

                </div>
              </div>
            </div>
          </div>
        </div>


        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow">
          <div className="container-fluid">
            <Link to="/" className="navbar-brand" >
              <img src={Mrindian} className="img-fluid " width="110" height="30" alt="Mrindiancoder" />
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a href='/' style={{ color: "#553C1E" }} className="nav-link active" aria-current="page" >  Home</a>
                </li>
      
<li className="nav-item dropdown">
     
          <a style={{color:"white"}} className="nav-link dropdown-toggle websiteconsult mt-0" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Get Expert Advice
          </a>
           
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a className="dropdown-item" href="talktoawebsite_debvelopment">Talk to a Website Development</a></li>
            <li><a className="dropdown-item" href="Businesstalk">Talk to a Business Guide</a></li>
            <li><hr className="dropdown-divider"/></li>
            <li><a className="dropdown-item" href="tel: +91 9933798896">Talk to a IT Guide </a></li>
          </ul>
        </li>
      
                <li className="nav-item">
                  <a href='about'  style={{ color: "#553C1E" }} className="nav-link active" aria-current="page" >About Us</a>
                </li>
                <li className="nav-item">
                  <a href='website-book'  style={{ color: "#553C1E" }} className="nav-link active" aria-current="page"> Website Plan Book</a>
                </li>


                <li className="nav-item">
                  <a href='our-development' style={{ color: "#553C1E" }} className="nav-link active" aria-current="page">  Our Client</a>
                </li>
             <li className="nav-item dropdown">
          <a style={{ color: "#553C1E" }}  className="nav-link dropdown-toggle " href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Services
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a className="dropdown-item" href="website-development">Website Development</a></li>
            <li><a className="dropdown-item" href="Maintenance-Support">Maintenance & Support</a></li>
           
          </ul>
        </li>
           <li className="nav-item">
                  <a href='blog' style={{ color: "#553C1E" }} className="nav-link" aria-current="page">Blog</a>
                </li>
       
                <li className="nav-item">
                  <a href='Contact' style={{ color: "#553C1E" }} className="nav-link" aria-current="page">  Contact</a>
                </li>

             
              </ul>

              <a style={{ color: "white" }} href="tel: +91 9933798896" className="buttonnav mb-2">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
              </svg> +91 9933798896*</a>


            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Header;

